import { gql, useQuery } from "@apollo/client";
import { PaymentSettings } from "../../__generated__/types";

const GET_PAYMENT_SETTINGS_QUERY = gql`
  query GetPaymentSettings {
    getPaymentSettings {
      _id
      paymentEnabled
      testMode
      testModeMessage
      lastUpdatedBy
      createdAt
      updatedAt
    }
  }
`;

export const useGetPaymentSettingsQuery = () => {
  const { data, loading, error, refetch } = useQuery<{ getPaymentSettings: PaymentSettings }>(
    GET_PAYMENT_SETTINGS_QUERY,
    {
      fetchPolicy: "network-only", // Always fetch fresh data
    }
  );

  return {
    paymentSettings: data?.getPaymentSettings,
    loading,
    error,
    refetch,
  };
};

